export default __webpack_public_path__ + "static/media/addCust.4cf91df9.svg";